import { onMounted, onUnmounted } from 'vue';

/**
 * Prompts the user to confirm before closing the page/tab.
 * @param condition A function that returns a boolean value. If the value is true, the user will be prompted.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
 */
export default function useConfirmBeforeClosing(condition: () => boolean = () => true) {
  /**
   * This dialog does not allow custom messaging for security reasons.
   * @see https://stackoverflow.com/questions/38879742/is-it-possible-to-display-a-custom-message-in-the-beforeunload-popup
   */
  function confirmBeforeClosing(event: BeforeUnloadEvent) {
    if (condition()) {
      event.preventDefault();
      return (event.returnValue = '');
    }
  }

  onMounted(() => addEventListener('beforeunload', confirmBeforeClosing));
  onUnmounted(() => removeEventListener('beforeunload', confirmBeforeClosing));
}
